import { Controller } from "stimulus";

// "Nova conversa" modal chrome: open/close, the channel toggle and the sender number field (shown
// while WhatsApp is the channel, its hint following the pick). The recipient search, paging and
// selection live in the importmap `recipient-picker` controller on the same form. Hosted by the
// turbo-modal frame over any page (closing empties the frame) or by the new page itself.
export default class extends Controller {
  static targets = ["overlay", "chanLabel", "senderField", "senderHint"];

  open() {
    if (this.hasOverlayTarget) this.overlayTarget.hidden = false;
  }

  close() {
    const frame = this.element.closest("turbo-frame");
    if (frame) {
      frame.innerHTML = "";
      return;
    }
    if (this.hasOverlayTarget) this.overlayTarget.hidden = true;
  }

  closeOnBackdrop(event) {
    if (event.target === this.overlayTarget) this.close();
  }

  pickChannel(event) {
    const label = event.currentTarget;
    const input = label.querySelector("input");
    if (input.disabled) return;

    this.chanLabelTargets.forEach((el) => el.classList.toggle("is-on", el === label));
    input.checked = true;
    this.syncSender(input.value);
  }

  // The sender number only makes sense on WhatsApp; leaving the channel resets it to the official one.
  syncSender(channel) {
    if (!this.hasSenderFieldTarget) return;

    const show = channel === "whatsapp";
    this.senderFieldTarget.hidden = !show;
    if (!show) {
      const select = this.senderFieldTarget.querySelector("select");
      select.value = "";
      this.refreshSenderHint(select);
    }
  }

  pickSender(event) {
    this.refreshSenderHint(event.currentTarget);
  }

  refreshSenderHint(select) {
    if (!this.hasSenderHintTarget) return;

    const hint = this.senderHintTarget;
    hint.textContent = select.value ? hint.dataset.unofficialHint : hint.dataset.officialHint;
  }
}
